import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { SERVICES } from '../mock';

const Services = () => {
  return (
    <section id="services" className="section bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-12">
          <span className="text-xs font-bold uppercase tracking-[0.25em] gold-text">Our Services</span>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold navy-text leading-tight">
            Transport options for every kind of vehicle.
          </h2>
          <p className="mt-4 text-lg text-[#4A5A72]">
            Built on more than a decade of combined experience as drivers, dispatchers and brokers — so every shipment runs smoothly from pickup to delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map(s => (
            <article key={s.id} className="card-lift group bg-white border border-[#E5EAF2] rounded-2xl overflow-hidden">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#D4A24C] text-[#0A1628] text-xs font-bold">{s.tag}</span>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-extrabold navy-text mb-2">{s.title}</h3>
                <p className="text-sm text-[#4A5A72] mb-5">{s.description}</p>
                <ul className="space-y-2 mb-6">
                  {s.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm">
                      <Check className="w-4 h-4 text-[#D4A24C] shrink-0 mt-0.5" />
                      <span className="text-[#0A1628]">{b}</span>
                    </li>
                  ))}
                </ul>
                <a href="/#quote">
                  <Button variant="outline" className="w-full font-semibold gap-1 hover:bg-[#0A1628] hover:text-white hover:border-[#0A1628] transition-colors">
                    Get a Quote <ArrowRight className="w-4 h-4" />
                  </Button>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
